module.exports = __webpack_public_path__ + "static/media/MoutainsLayerOne.31522415.png";